import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClient } from './useClient';
import { UpdateAccountConfigRequest } from '@hud/rules-dtos/api-rules.dtos';
import { RULE_ID } from './useRule';

export function useUpdateAccountConfigMutation(ruleId: string) {
  const { client } = useClient('detection');
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: UpdateAccountConfigRequest) =>
      client.put(`/rules/${ruleId}/account-config`, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [RULE_ID, ruleId] });
    },
  });
}
